import { render, staticRenderFns } from "./termsDialog.vue?vue&type=template&id=0af777e2&lang=pug"
import script from "./termsDialog.vue?vue&type=script&lang=js"
export * from "./termsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports